<template lang="pug">
  .component.component-backoffice-note(v-if="item")
    .card( v-if="$is('listing')")
      .inner-content
        cardN(:showBullets="true", :showAction="true", :columns="8")
          div(slot="actionBullets")
            dropdown(:icon="'fa fa-ellipsis-v fa-2x action'", :position="'top'")
              DocumentTypeButtons(:item="item")
          .field-value(slot="n1") DT{{item.id}}
          .field-value(slot="n1") {{item.name}}
          .field-value(slot="n2") Description
          .field-value(slot="n2") {{item.description}}
          .field-value(slot="n3") Attachment views
          .field-value(slot="n3") {{item.attachment_views.join(' - ')}}
          .field-value(slot="n4") Number required
          .field-value(slot="n4") {{item.has_number ? 'Yes' : 'No'}}
          .field-value(slot="n5") Emission required
          .field-value(slot="n5") {{item.has_emission ? 'Yes' : 'No'}}
          .field-value(slot="n6") Expiry required
          .field-value(slot="n6") {{item.has_expiry ? 'Yes' : 'No'}}
          .field-value(slot="n7") Issuer required
          .field-value(slot="n7") {{item.has_issuer ? 'Yes' : 'No'}}
          .field-value(slot="n8") Country required
          .field-value(slot="n8") {{item.has_country ? 'Yes' : 'No'}}


</template>
<script type="text/babel">
  import CardN from 'components/structure/CardN'
  import Dropdown from '../structure/foundation/Dropdown'
  import VehicleCostButtons from '../structure/ui/actions/VehicleCostButtons'
  import VehicleNoteButtons from '../structure/ui/actions/VehicleNoteButtons'
  import {mapState} from 'vuex'
  import TocButtons from '../structure/ui/actions/TocButtons'
  import TocTypeButtons from '../structure/ui/actions/TocTypeButtons'
  import DocumentTypeButtons from '../structure/ui/actions/DocumentTypeButtons'

  export default {
    name: 'DocumentType',
    components: {
      DocumentTypeButtons,
      TocTypeButtons,
      TocButtons,
      Dropdown,
      CardN,
    },
    data() {
      return {}
    },
    created() {
    },
    methods: {},
    computed: {},
    props: {
      item: Object,
      type: {
        type: String,
        default: ''
      }
    },
  }
</script>
<style lang="sass" rel="stylesheet/sass">
</style>



// WEBPACK FOOTER //
// DocumentType.vue?387fc7c2